var map = {
	"./interps": 63527,
	"./interps.js": 63527,
	"./report-button": 57633,
	"./report-button.js": 57633,
	"./spread-card": 88140,
	"./spread-card.js": 88140,
	"./spread-partial": 89739,
	"./spread-partial.js": 89739,
	"./spreads/base-spread": 8722,
	"./spreads/base-spread.js": 8722,
	"./spreads/horoscope-tarot": 86306,
	"./spreads/horoscope-tarot.js": 86306,
	"./spreads/mandala": 44319,
	"./spreads/mandala.js": 44319,
	"./spreads/yes-or-no": 45170,
	"./spreads/yes-or-no.js": 45170,
	"./tarot-spread": 28989,
	"./tarot-spread.js": 28989,
	"./teeup": 17793,
	"./teeup.js": 17793
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76242;